import React, { useState, useRef, useEffect } from 'react';

interface ComponentProps {
  buttonText?: string;
  title?: string;
  children?: React.ReactNode;
}

const Popover: React.FC<ComponentProps> = ({ buttonText, title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);

  // Handle click outside to close popover
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node;

      if (
        popoverRef.current &&
        buttonRef.current &&
        !popoverRef.current.contains(target) &&
        !buttonRef.current.contains(target)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const togglePopover = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      {/* Display Button */}
      <div
        ref={buttonRef}
        onClick={togglePopover}
        className="px-4 py-2 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:cursor-pointer focus:ring-ingle-light-purple focus:border-ingle-light-purple"
      >
        {buttonText}
      </div>

      {/* Popover */}
      {isOpen && (
        <div
          ref={popoverRef}
          className="absolute mt-2 bg-white rounded-md shadow-lg border border-gray-200 z-10 animate-in fade-in"
        >
          <div className="p-2">
            <div className="pl-5 pt-5">{title}</div>

            {children}
          </div>
        </div>
      )}
    </div>
  );
};
export default Popover;
